import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';

// eslint-disable-next-line no-unused-vars
const swiper = new Swiper('#js-home-slider', {
	// configure Swiper to use modules
	modules: [Navigation, Pagination],
	pagination: {
		el: '.p-home-slider__pagination',
	},
	navigation: {
		nextEl: '.p-home-slider__next',
		prevEl: '.p-home-slider__prev',
	},
	slidesPerView: 1,
	spaceBetween: 20,
	breakpoints: {
		500: {
			slidesPerView: 2,
		},
		768: {
			slidesPerView: 4,
		},
		1080: {
			slidesPerView: 5,
		},
	}
});